import Swiper from 'swiper'

let carouselSwiper;

export default class Home {
    constructor() {
        if (document.getElementById('pageHome') !== null) {
            this.initHero();
            this.initProductCarousel();
            this.resizeWindow();
        }
    }

    resizeWindow() {
        let resizeTimer;
        window.addEventListener('resize', e => {
            if (resizeTimer) clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.initProductCarousel();
            }, 100, e);
        });
    }

    initHero() {
        new Swiper('#hero .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            speed: 1000,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            autoplay: {
                delay: 3500,
            },
        })
    }

    initProductCarousel() {
        if (carouselSwiper !== undefined) {
            carouselSwiper.destroy(true, true);
            carouselSwiper = undefined;
        }

        if (window.innerWidth >= 576) {

            if (carouselSwiper === undefined) {
                carouselSwiper = new Swiper('#productCarousel .swiper-container', {
                    slidesPerView: 1,
                    // spaceBetween: 16,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3,
                            // spaceBetween: 20
                        },
                        1200: {
                            slidesPerView: 4,
                            // spaceBetween: 30
                        }
                    }
                });
            }
        }
    }
}
